import { BucketIdentifier, S3File } from "@dune/types";
import { Control, Controller, FieldPath, FieldValues } from "react-hook-form";
import { S3FileInput } from "../common/S3FileInput";

interface ControlledS3FileInputProps<T extends FieldValues> {
	name: FieldPath<T>;
	control: Control<T>;
	bucket: BucketIdentifier;
	label?: string;
	onPreview?: (file: S3File) => void;
	removeFile?: () => void;
	subText?: string;
	hidePreviewButton?: boolean;
}

const ControlledS3FileInput = <T extends FieldValues>({
	name,
	control,
	bucket,
	label,
	onPreview,
	removeFile,
	subText,
	hidePreviewButton,
}: ControlledS3FileInputProps<T>) => {
	return (
		<div className="space-y-2 w-full">
			{label && <div>{label}</div>}
			<Controller
				name={name}
				control={control}
				render={({ field }) => (
					<S3FileInput
						bucket={bucket}
						onUploadSuccess={(s3File: S3File) =>
							field.onChange({
								name: s3File.name,
								bucket: s3File.bucket,
								key: s3File.key,
								type: s3File.type,
								size: s3File.size,
								url: s3File.url,
							})
						}
						onRemove={() => {
							removeFile?.();
						}}
						onPreview={onPreview}
						subText={subText}
						hidePreviewButton={hidePreviewButton}
						initialFile={field.value?.key ? field.value : undefined}
					/>
				)}
			/>
		</div>
	);
};

export { ControlledS3FileInput };
